import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import '../../Dashboard Style/UpgradePlan.css';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { getAllPlansApi, getAllPlanAmountsApi, upgradePlanByMainVaultApi } from '../../Services/Operations/ProductAPI';

const UpgradePlan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const userData = useSelector((state) => state.user?.userData);
  const authToken = useSelector((state) => state.user?.token);
  
  const [plans, setPlans] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  
  const currentWalletBalance = userData?.wallets?.main_wallet || 0;
  const hasSufficientBalance = selectedAmount ? currentWalletBalance >= selectedAmount.amountValue : false;
  const balanceDifference = selectedAmount ? selectedAmount.amountValue - currentWalletBalance : 0;

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

  
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {};
  }, [sidebarOpen]);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      /* Deep Space Background */
      .page-content {
        background: radial-gradient(circle at top right, #0a1a15, #000000) !important;
        min-height: 100vh;
        padding: 30px 15px;
        color: #e0e0e0;
      }
      
      /* Reduced Font Sizes */
      .upgrade-header h1 {
        font-size: 1.8rem !important;
        margin-bottom: 0.5rem !important;
      }
      
      .upgrade-header p {
        font-size: 0.9rem !important;
        margin-bottom: 0 !important;
      }
      
      .section-title {
        font-size: 1.3rem !important;
        margin-bottom: 1rem !important;
      }
      
      .card-title {
        font-size: 1.1rem !important;
      }
      
      .card-text {
        font-size: 0.85rem !important;
      }
      
      /* Gradient Text */
      .gradient-text {
        background: linear-gradient(90deg, #ffffff, #10b981);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 1.8rem !important;
        font-weight: 700;
      }
      
      /* Glassmorphism Cards */
      .glass-card {
        background: rgba(255, 255, 255, 0.03);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 16px;
        position: relative;
        overflow: hidden;
      }
      
      /* Balance Card Specifics */
      .balance-card {
        padding: 20px;
        border-left: 4px solid #10b981;
      }
      
      .wallet-info {
        display: flex;
        align-items: center;
        gap: 15px;
      }
      
      .balance-amount {
        font-size: 2rem !important;
        font-weight: 800;
        color: #10b981;
        margin: 0;
        text-shadow: 0 0 20px rgba(16, 185, 129, 0.3);
      }
      
      /* Plan Grid - Modern Minimalist */
      .plan-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 15px;
      }
      
      .plan-item {
        background: rgba(255, 255, 255, 0.02);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 14px;
        padding: 20px;
        cursor: pointer;
        transition: all 0.3s ease;
        min-height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      
      .plan-item:hover:not(.inactive) {
        background: rgba(255, 255, 255, 0.05);
        border-color: #3b82f6;
        transform: translateY(-5px);
      }
      
      .plan-item.active {
        background: linear-gradient(145deg, rgba(16, 185, 129, 0.1), rgba(16, 185, 129, 0.05));
        border-color: #10b981;
        box-shadow: 0 8px 25px rgba(16, 185, 129, 0.15);
      }
      
      .plan-item.inactive {
        cursor: not-allowed;
        opacity: 0.5;
        background: rgba(255, 255, 255, 0.01);
      }
      
      .plan-name {
        font-size: 0.75rem !important;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        color: #94a3b8;
        margin-bottom: 8px;
      }
      
      .plan-status {
        font-size: 0.75rem !important;
        padding: 4px 10px;
        border-radius: 20px;
        display: inline-block;
      }
      
      /* Amount Cards - Smaller */
      .amount-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        gap: 12px;
      }
      
      .amount-item {
        background: rgba(255, 255, 255, 0.02);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        padding: 15px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-align: center;
        min-height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      
      .amount-item:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: #10b981;
        transform: translateY(-3px);
      }
      
      .amount-item.active {
        background: linear-gradient(145deg, rgba(16, 185, 129, 0.1), rgba(16, 185, 129, 0.05));
        border-color: #10b981;
        box-shadow: 0 5px 20px rgba(16, 185, 129, 0.15);
      }
      
      .amount-value {
        font-size: 1.3rem !important;
        font-weight: 700;
        margin: 5px 0;
        color: #10b981;
      }
      
      /* Summary Box */
      .summary-box {
        padding: 15px;
        border-radius: 12px;
        margin-bottom: 15px;
      }
      
      .summary-box.valid { 
        background: rgba(16, 185, 129, 0.1); 
        color: #10b981; 
        border: 1px solid rgba(16, 185, 129, 0.2); 
      }
      
      .summary-box.invalid { 
        background: rgba(239, 68, 68, 0.1); 
        color: #ef4444; 
        border: 1px solid rgba(239, 68, 68, 0.2); 
      }
      
      /* Upgrade Button */
      .upgrade-btn-main {
        width: 100%;
        padding: 15px;
        border-radius: 12px;
        border: none;
        background: linear-gradient(90deg, #10b981, #059669);
        color: white;
        font-weight: 600;
        font-size: 1rem;
        transition: 0.3s;
        text-transform: uppercase;
        letter-spacing: 1px;
        max-width: 300px;
        margin: 0 auto;
      }
      
      .upgrade-btn-main:hover:not(.disabled) {
        transform: scale(1.02);
        box-shadow: 0 0 30px rgba(16, 185, 129, 0.4);
      }
      
      .upgrade-btn-main.disabled {
        background: #334155;
        cursor: not-allowed;
        opacity: 0.6;
      }
      
      /* Current Status Badge */
      .current-status-badge {
        background: rgba(255, 255, 255, 0.05);
        padding: 8px 15px;
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      .current-status-badge .label {
        font-size: 0.75rem;
        color: #94a3b8;
        display: block;
      }
      
      .current-status-badge .value {
        font-size: 0.9rem;
        font-weight: 600;
        color: #10b981;
      }
      
      /* Container sizing */
      .upgrade-container {
        max-width: 1200px;
        margin: 0 auto;
      }
      
      /* Dark theme text */
      .dark-theme * {
        color: #e0e0e0 !important;
      }
      
      .dark-theme .text-muted {
        color: #94a3b8 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Fetch plans and amounts from APIs
  useEffect(() => {
    const fetchPlanData = async () => {
      try {
        setLoading(true);
        
        // Fetch plans
        const plansResult = await getAllPlansApi(authToken);
        if (plansResult.status && plansResult.data) {
          setPlans(plansResult.data);
        } else {
          toast.error(plansResult.message || 'Failed to load plans');
        }
        
        // Fetch amounts
        const amountsResult = await getAllPlanAmountsApi(authToken);
        if (amountsResult.status && amountsResult.data) {
          const parsedAmounts = amountsResult.data.map(item => ({
            ...item,
            amountValue: parseFloat(item.amount.replace(/[$,]/g, ''))
          }));
          setAmounts(parsedAmounts);
        } else {
          toast.error(amountsResult.message || 'Failed to load plan amounts');
        }
      } catch (error) {
        console.error('Error fetching plan data:', error);
        toast.error('Error loading plan information');
      } finally {
        setLoading(false);
      }
    };

    if (authToken) {
      fetchPlanData();
    }
  }, [authToken]);

  const handlePlanSelect = (plan) => {
    if (plan.package_status === 'Inactive') {
      return; // Don't select inactive plans
    }
    setSelectedPlan(plan);
  };

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedPlan) {
      toast.error('Please select a plan');
      return;
    }
    
    if (!selectedAmount) {
      toast.error('Please select an amount');
      return;
    }
    
    if (!hasSufficientBalance) {
      toast.error(`Insufficient balance. You need $${balanceDifference.toFixed(2)} more in your Quantum Main Vault`);
      return;
    }
    
    setIsProcessing(true);
    
    try {
      const planData = {
        plan_id: selectedPlan.id,
        plan_name: selectedPlan.package_name,
        amount_id: selectedAmount.id,
        amount: selectedAmount.amount,
        amount_value: selectedAmount.amountValue,
        user_id: userData?.id || '',
      };
      
      console.log('Plan Upgrade Data:', planData);
      
      const result = await upgradePlanByMainVaultApi(authToken, planData);
      
      console.log('Plan Upgrade Result:', result);
      
      if (result.status === true) {
        toast.success(result.message || 'Plan upgraded successfully!');
        
        setTimeout(() => {
          navigate('/dashboard', {
            state: {
              upgradeSuccess: true,
              planName: selectedPlan.package_name,
              amount: selectedAmount.amount,
              message: 'Your plan has been successfully upgraded!'
            }
          });
        }, 3000);
      } else {
        toast.error(result.message || 'Failed to upgrade plan. Please try again.');
        console.error('Upgrade failed with message:', result.message);
      }
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      toast.error('An unexpected error occurred. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
       <Sidebar
                   isOpen={!sidebarOpen}
                   onClose={closeSidebar}
                 />
       
                 {/* Mobile backdrop */}
                 {isMobile && sidebarOpen && (
                   <div
                     className="sidebar-backdrop"
                     onClick={closeSidebar}
                   />
                 )}
      </nav>

      <div className="page-wrapper">
        <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
            isMobile={isMobile}/>

        
        <div className="page-content container-fluid">
          <div className="upgrade-container">
            
            {/* Header Section */}
            <header className="upgrade-header mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h1 className="gradient-text">Upgrade Your Plan</h1>
                  <p className="text-muted">Choose a plan and amount to upgrade your quantum experience</p>
                </div>
                <div className="current-status-badge">
                  <span className="label">Current Plan</span>
                  <span className="value">Aware</span>
                </div>
              </div>
            </header>

            {/* Wallet Balance Card */}
            <div className="card glass-card balance-card mb-4">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h5 className="card-title mb-2">QUANTUM MAIN VAULT BALANCE</h5>
                    <h2 className="balance-amount mb-2">${currentWalletBalance.toFixed(2)}</h2>
                    <p className="text-muted mb-0">Available for plan upgrade</p>
                  </div>
                  <div className="col-md-4 text-end">
                    <i className="bi bi-wallet2" style={{ fontSize: '3rem', opacity: 0.7 }}></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Loading State */}
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" style={{ width: '2.5rem', height: '2.5rem' }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading plans and amounts...</p>
              </div>
            ) : (
              <>
                {/* Plan Selection Section */}
                <section className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="section-title fw-bold">Select a Plan</h3>
                    <span className="badge bg-primary" style={{ fontSize: '0.75rem' }}>
                      {plans.filter(p => p.package_status === 'Active').length} Active Plans
                    </span>
                  </div>
                  
                  {plans.length === 0 ? (
                    <div className="alert alert-info py-2" style={{ fontSize: '0.85rem' }}>
                      <i className="bi bi-info-circle me-2"></i>
                      No plans available at the moment.
                    </div>
                  ) : (
                    <div className="plan-grid">
                      {plans.map((plan) => {
                        const isActive = plan.package_status === 'Active';
                        const isSelected = selectedPlan?.id === plan.id;
                        
                        return (
                          <div 
                            key={plan.id}
                            className={`plan-item ${isSelected ? 'active' : ''} ${!isActive ? 'inactive' : ''}`}
                            onClick={() => handlePlanSelect(plan)}
                          >
                            <div className="plan-name">{plan.package_name}</div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <span className={`plan-status ${isActive ? 'bg-success' : 'bg-secondary'}`}>
                                  {isActive ? 'Active' : 'Inactive'}
                                </span>
                              </div>
                              <div>
                                <i className={`bi ${isActive ? 'bi-check-circle-fill text-success' : 'bi-clock text-secondary'}`}></i>
                              </div>
                            </div>
                            <p className="card-text text-muted mt-2 mb-0">
                              {isActive ? 'Available for upgrade' : 'Coming soon'}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </section>

                {/* Amount Selection Section */}
                <section className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="section-title fw-bold">Select an Amount</h3>
                    <span className="badge bg-success" style={{ fontSize: '0.75rem' }}>
                      {amounts.length} Amounts Available
                    </span>
                  </div>
                  
                  {amounts.length === 0 ? (
                    <div className="alert alert-info py-2" style={{ fontSize: '0.85rem' }}>
                      <i className="bi bi-info-circle me-2"></i>
                      No amounts available at the moment.
                    </div>
                  ) : (
                    <div className="amount-grid">
                      {amounts.map((amount) => {
                        const isSelected = selectedAmount?.id === amount.id;
                        
                        return (
                          <div 
                            key={amount.id}
                            className={`amount-item ${isSelected ? 'active' : ''}`}
                            onClick={() => handleAmountSelect(amount)}
                          >
                            <div className="amount-value">{amount.amount}</div>
                            <p className="card-text text-muted mb-0" style={{ fontSize: '0.75rem' }}>
                              Upgrade amount
                            </p>
                            {isSelected && (
                              <div className="mt-2">
                                <span className="badge bg-info" style={{ fontSize: '0.7rem' }}>
                                  Selected
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </section>

                {/* Selection Summary */}
                {(selectedPlan || selectedAmount) && (
                  <div className="mb-4">
                    <h3 className="section-title fw-bold mb-3">Upgrade Summary</h3>
                    
                    <div className="row g-3 mb-3">
                      {/* Selected Plan */}
                      {selectedPlan && (
                        <div className="col-md-6">
                          <div className="summary-box valid">
                            <div className="d-flex align-items-center">
                              <div className="me-3">
                                <i className="bi bi-check-circle-fill" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="card-title mb-1">Selected Plan</h6>
                                <p className="mb-0 fw-bold">{selectedPlan.package_name}</p>
                                <small className="text-muted">ID: {selectedPlan.id}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Selected Amount */}
                      {selectedAmount && (
                        <div className="col-md-6">
                          <div className="summary-box valid">
                            <div className="d-flex align-items-center">
                              <div className="me-3">
                                <i className="bi bi-currency-dollar" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="card-title mb-1">Selected Amount</h6>
                                <p className="mb-0 fw-bold">{selectedAmount.amount}</p>
                                <small className="text-muted">Value: ${selectedAmount.amountValue.toFixed(2)}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Balance Check */}
                    {selectedAmount && (
                      <div className={`summary-box ${hasSufficientBalance ? 'valid' : 'invalid'}`}>
                        <div className="row align-items-center">
                          <div className="col-md-8">
                            <div className="d-flex align-items-center">
                              <div className="me-3">
                                <i className={`bi ${hasSufficientBalance ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'}`} style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="card-title mb-1">
                                  {hasSufficientBalance ? 'Sufficient Balance ✓' : 'Insufficient Balance ✗'}
                                </h6>
                                <p className="mb-0" style={{ fontSize: '0.85rem' }}>
                                  {hasSufficientBalance
                                    ? `Your Quantum Main Vault has sufficient funds for this upgrade`
                                    : `You need $${balanceDifference.toFixed(2)} more to proceed with this upgrade`}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 text-end">
                            <p className="mb-0" style={{ fontSize: '0.85rem' }}>
                              <strong>Required:</strong> {selectedAmount.amount}<br />
                              <strong>Available:</strong> ${currentWalletBalance.toFixed(2)}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Action Button */}
                <div className="text-center mt-4">
                  <button 
                    className={`upgrade-btn-main ${!hasSufficientBalance || !selectedPlan || !selectedAmount || isProcessing ? 'disabled' : ''}`}
                    onClick={handleSubmit}
                    disabled={!hasSufficientBalance || !selectedPlan || !selectedAmount || isProcessing}
                  >
                    {isProcessing ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Processing Upgrade...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-rocket-takeoff-fill me-2"></i>
                        Confirm Upgrade Now
                      </>
                    )}
                  </button>
                  
                  {(!selectedPlan || !selectedAmount) && (
                    <p className="text-muted mt-3" style={{ fontSize: '0.85rem' }}>
                      Please select both a plan and an amount to proceed
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-0" style={{ fontSize: '0.85rem' }}>Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default UpgradePlan;